const general_en = require("./general_en");
const general_ru = require("./general_ru");

// Standart-pages
const homepage_en = require("./pages/homepage_en");
const homepage_ru = require("./pages/homepage_ru");
const contacts_en = require("./pages/contacts_en");
const contacts_ru = require("./pages/contacts_ru");
const ndt_en = require("./pages/ndt_en");
const ndt_ru = require("./pages/ndt_ru");
const mex_en = require("./pages/mex_en");
const mex_ru = require("./pages/mex_ru");
const knoledgebase_en = require("./pages/knoledgebase_en");
const knoledgebase_ru = require("./pages/knoledgebase_ru");
const privacy_en = require("./pages/privacy_en");
const privacy_ru = require("./pages/privacy_ru");
const presentation_en = require("./pages/presentation_en");
const presentation_ru = require("./pages/presentation_ru");
const stroylab_en = require("./pages/stroylab_en");
const stroylab_ru = require("./pages/stroylab_ru");

// Program-pages
const program_pages_en = require("./pages/program_pages_en");
const program_pages_ru = require("./pages/program_pages_ru");

let lng = null;
module.exports = {
  en: {
    lng: "en", ...general_en, ...homepage_en, ...contacts_en, ...privacy_en,
    ...ndt_en, ...mex_en, ...knoledgebase_en,
    ...presentation_en, ...program_pages_en, ...stroylab_en
  },
  ru: {
    lng: "ru", ...general_ru, ...homepage_ru, ...contacts_ru, ...privacy_ru,
    ...ndt_ru, ...mex_ru, ...knoledgebase_ru,
    ...presentation_ru, ...program_pages_ru, ...stroylab_ru
  },
  get: () => {
    const isClientSide = !(typeof process !== "undefined" && (process.release.name.search(/node|io.js/) !== -1));
    if (isClientSide) { return (document.title === general_en.header.title ? "en" : "ru") } // For Client-side
    return (lng || "ru"); // For Server-side
  },
  set: (lngparam) => { lng = lngparam }
};
